import UserEventContextValueProvider from "../../../App/Compositions/UserEventContextValueProvider";
import CenterSelector, { IEventfulCenterSelectorProps } from "../Components/CenterSelector";
import { ICenterSelectorProps } from "../Components/CenterSelectStep";

/** A Center Selector which reports user events on interaction. */
const UserEventCenterSelector: React.FC<ICenterSelectorProps> =
  UserEventContextValueProvider<IEventfulCenterSelectorProps>({ Component: CenterSelector });

export default UserEventCenterSelector;
